export const SETTINGS_TITLE = 'Image Settings'

export const IMAGE_SETTINGS = {
    rotate:{
        label: "Rotate",
        min: 0,
        max: 360
    },
    scale: {
        label: "Scale",
        min: 1,
        max: 100
    }
}